import { blue50, blue60 } from '../../../colors/blue';
import { gray40opacity15, gray55, gray80 } from '../../../colors/gray';
import { neutral60opacity10 } from '../../../colors/neutral';
import { red03, red04 } from '../../../colors/red';
import { yellow02, yellow03 } from '../../../colors/yellow';
import { rem } from '../../../utils/rem';
import { shape } from '../shape';
import { MuiListItem } from './MuiListItem';
// Style listItemButtom with the same style as listItem
export var MuiListItemButton = {
    styleOverrides: MuiListItem.styleOverrides,
    customOverrides: {
        topNavItem: {
            fontWeight: 500,
            borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
            minHeight: 34,
            padding: '0 12px',
            whiteSpace: 'nowrap',
            '& .MuiListItemText-primary': {
                fontWeight: 500,
            },
            "&[class*='Mui-selected']": {
                color: blue50,
            },
            '&:not(:last-child)': {
                marginRight: 8,
            },
        },
        topNavItemOverflow: {
            '& .YdsSvgIcon-root': {
                marginLeft: 8,
            },
        },
        topNavButton: {
            fontWeight: 600,
            borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
            color: gray55,
            height: 36,
            justifyContent: 'center',
            padding: '0px 8px',
            minWidth: 36,
            width: 'unset',
            gap: '6px',
            '& .MuiBadge-badge': {
                fontWeight: 600,
            },
            "&[class*='Mui-selected']": {
                color: blue50,
            },
            '&:not(:last-child)': {
                marginRight: 8,
            },
            warning: {
                '--yds-top-nav-btn-color': yellow02,
                '--yds-top-nav-btn-color-hover': yellow03,
                '--yds-top-nav-btn-text-color': gray80,
            },
            error: {
                '--yds-top-nav-btn-color': red03,
                '--yds-top-nav-btn-color-hover': red04,
                '--yds-top-nav-btn-text-color': 'white',
            },
            // Shared styles for warning / important.
            customColor: {
                '&&.MuiListItemButton-root': {
                    backgroundColor: 'var(--yds-top-nav-btn-color)',
                    color: 'var(--yds-top-nav-btn-text-color)',
                    '&:hover': {
                        backgroundColor: 'var(--yds-top-nav-btn-color-hover)',
                    },
                    '&[class*=Mui-selected]:not(:focus-visible)': {
                        outline: "solid 1px var(--yds-top-nav-btn-color)",
                        outlineOffset: 1,
                        '&:hover': {
                            outlineColor: 'var(--yds-top-nav-btn-color-hover)',
                        },
                    },
                },
            },
        },
        sideNavItem: {
            marginBlock: rem(4),
            borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
            color: gray80,
            paddingBlock: rem(6),
            paddingInline: rem(12),
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            '& [class*=MuiListItemIcon-root]': {
                color: gray55,
            },
            '& [class*=MuiListItemText-root]': {
                '& [class*=MuiTypography-root]': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    minWidth: 0,
                },
            },
            '&:hover': { backgroundColor: neutral60opacity10 },
            '&[class*=Mui-selected]': {
                backgroundColor: gray40opacity15,
                color: blue60,
                '& [class*=MuiListItemIcon-root]': {
                    color: 'inherit',
                },
                '& [class*=MuiListItemText-primary]': {
                    fontWeight: '500',
                },
            },
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 1px ".concat(blue60),
                '&:not(:hover)': { backgroundColor: 'transparent' },
            },
        },
    },
};
